import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { URLs } from '../../constants/route'

function queryString(name, url = window.location.href) {
  name = name.replace(/[[]]/g, '\\$&')

  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i')
  const results = regex.exec(url)

  if (!results) {
    return null
  }
  if (!results[2]) {
    return ''
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export default function UnauthenticatedRoute({
  path,
  component,
  accessToken,
  exact,
  roles,
  ...rest
}) {
  const C = component
  const redirect = queryString('redirect')
  return (
    <Route
      path={path}
      exact={exact}
      render={props =>
        !accessToken ? (
          <C {...props} {...rest} />
        ) : (
          <Redirect to={redirect || URLs.DASHBOARD} />
        )
      }
    />
  )
}

UnauthenticatedRoute.propTypes = {
  accessToken: PropTypes.string.isRequired
}
